const findLinkInIframe = (element) => {
    if(!element?.nodeName || element.nodeName === "BODY"){
        return;
    }

    if(element.nodeName === "A") {
        return element;
    }

    const parentElement = element.parentElement;

    return findLinkInIframe(parentElement);
};

export default findLinkInIframe;
